var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AppBar, useAuthProvider } from 'react-admin';
import { Typography, withStyles } from '@material-ui/core';
import Logo from './Logo';
const styles = {
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
};
const CustomAppBar = (_a) => {
    var { classes, userMenu } = _a, props = __rest(_a, ["classes", "userMenu"]);
    const authProvider = useAuthProvider();
    return (React.createElement(AppBar, Object.assign({ userMenu: userMenu !== null && userMenu !== void 0 ? userMenu : !!authProvider }, props),
        React.createElement(Typography, { variant: "h6", color: "inherit", className: classes.title, id: "react-admin-title" }),
        React.createElement(Logo, null),
        React.createElement("span", { className: classes.spacer })));
};
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export default withStyles(styles)(CustomAppBar);
//# sourceMappingURL=AppBar.js.map